
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface StatusHistoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  statusHistory: any[];
}

export const StatusHistoryDialog = ({
  open,
  onOpenChange,
  statusHistory,
}: StatusHistoryDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Durum Geçmişi</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tarih</TableHead>
                <TableHead>Eski Durum</TableHead>
                <TableHead>Yeni Durum</TableHead>
                <TableHead>Değiştiren</TableHead>
                <TableHead>Notlar</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {statusHistory.map((history) => (
                <TableRow key={history.id}>
                  <TableCell>{new Date(history.created_at).toLocaleDateString('tr-TR')}</TableCell>
                  <TableCell>{history.old_status || '-'}</TableCell>
                  <TableCell>{history.new_status}</TableCell>
                  <TableCell>{history.changed_by.email}</TableCell>
                  <TableCell>{history.notes || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};
